import { getBodySelectedData, setBodySelectedData } from './BodyAdapter';
import { getSubjectSelectedData, setSubjectSelectedData } from './SubjectAdapter';
export var getSelectedData = function (viewState) { return function () {
    if (viewState.lastFocusedControl === 7 /* Editor */) {
        return getBodySelectedData(viewState)();
    }
    else if (viewState.lastFocusedControl === 5 /* SubjectLine */) {
        return getSubjectSelectedData(viewState)();
    }
    return null;
}; };
export var setSelectedData = function (viewState) { return function (content) {
    if (viewState.lastFocusedControl === 7 /* Editor */) {
        setBodySelectedData(viewState)(content);
    }
    else if (viewState.lastFocusedControl === 5 /* SubjectLine */) {
        setSubjectSelectedData(viewState)(content);
    }
    return;
}; };
//# sourceMappingURL=SelectedDataAdapter.js.map